/*
PROV: COHINT001.BF.7CCFGS017L
REQ: SYS-ARCH-15
WHY: Frontend application module.
*/

import { createLogger } from "@cohorta/shared/observability/log";

export const logger = createLogger({ service: "support" });
